import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

// https://profiledataform.herokuapp.com/

axios.defaults.baseURL = "https://djsce-it-portal.onrender.com";

// axios.defaults.baseURL = 'http://localhost:8800/';

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    const tokenConfig = config;
    const token = localStorage.getItem('token');
    if (token) {
      tokenConfig.headers.Authorization = `Bearer ${token}`;
    }
    return tokenConfig;
  },
  error => {
    // Do something with request error
    return Promise.reject(error.data.msg);
  }
);
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
